import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

type Job = {id: string; pipeline_stage_name: string; lost_reason?: string; stage_before_lost?: string};
export default function JobDisposition({job, onSaved, initiallyOpen = false}: {job: Job; onSaved: () => void; initiallyOpen?: boolean}) {
  const {user} = useAuth();
  const [open, setOpen] = useState(initiallyOpen);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const lost = job.pipeline_stage_name === 'Lost';
  if (!['admin','specialist','pm'].includes(user?.role || '')) return null;
  const save = async () => {
    setBusy(true); setError('');
    try {
      await api.post(`/jobs/${job.id}/disposition`, {lost: !lost, reason: reason.trim(), expected_stage:job.pipeline_stage_name});
      setOpen(false); setReason(''); onSaved();
    } catch (e: any) { setError(e.response?.data?.error || 'Unable to update this job.'); }
    finally {setBusy(false);}
  };
  const button: React.CSSProperties = {width:'100%',padding:12,borderRadius:10,border:'1px solid #2D4259',background:'#243447',color:lost?'#8FA8C0':'#EF4444',fontWeight:700,cursor:'pointer'};
  return <div style={{marginTop:12}}>
    {lost && <p style={{color:'#8FA8C0',fontSize:13,whiteSpace:'pre-wrap'}}>{job.lost_reason}</p>}
    <button style={button} onClick={() => {setError('');setOpen(true);}}>{lost?'Reopen Job':'Job Lost'}</button>
    {open && <div role="dialog" aria-modal="true" aria-label={lost?'Reopen Job':'Job Lost'} style={{position:'fixed',inset:0,zIndex:1100,background:'#0009',display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div style={{background:'#1A2B3C',border:'1px solid #2D4259',borderRadius:16,padding:24,width:440,maxWidth:'100%'}}>
        <h2 style={{color:'#fff',marginTop:0}}>{lost?'Reopen Job':'Job Lost'}</h2>
        <p style={{color:'#8FA8C0',lineHeight:1.5}}>{lost?`Return this job to ${job.stage_before_lost || 'its previous stage'}?`:'Move this job to Lost and keep its customer information, documents, payments, and commission history.'}</p>
        {!lost && <label style={{color:'#8FA8C0',fontSize:13,fontWeight:700}}>REASON<textarea aria-label="Lost reason" value={reason} maxLength={2000} onChange={e=>setReason(e.target.value)} placeholder="For example: Homeowner chose another company" style={{display:'block',boxSizing:'border-box',width:'100%',minHeight:100,marginTop:8,padding:12,borderRadius:10,border:'1px solid #2D4259',background:'#243447',color:'#fff'}} /></label>}
        {error && <p role="alert" style={{color:'#EF4444'}}>{error}</p>}
        <div style={{display:'flex',gap:12,marginTop:20}}>
          <button style={button} disabled={busy} onClick={()=>setOpen(false)}>Cancel</button>
          <button style={{...button,background:'#4A7EB5',color:'#fff'}} disabled={busy || (!lost&&!reason.trim())} onClick={save}>{busy?'Saving…':lost?'Reopen Job':'Move to Lost'}</button>
        </div>
      </div>
    </div>}
  </div>;
}
